export default "__VITE_ASSET__BmW8lo$5__"